import React, { useRef, useEffect, useState } from "react";
import ReactToPrint from "react-to-print";
import { useDispatch } from "react-redux";
import { openSnackbar } from "../../../Redux/Actions/snackbarActions";
import grnService from "../../../Service/Stock/grn.service";
import Loading from "../../MUI_components/loading";
import { currency } from "../../MUI_components/currencyFormatterTag";
import { Button, Grid, Paper, Typography } from "@mui/material";

import { styled } from "@mui/material/styles";
import Reports from "Components/Print/a4-report-print";
import purchaseReturnService from "Service/Suppliers/purchaseReturn.service";
import { company } from "titum-custom/details";
import Details from "../../CompnayDetails/details"
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { useQuery } from "react-query";
import { REACT_QUERY_KEYS } from "Components/Constants/ReactQueryKeys";
import ErrorMessage from "Components/MUI_components/ErrorMessage";

const PREFIX = "ViewGrn";
const classes = {
  root: `${PREFIX}-root`,
  printArea: `${PREFIX}-printArea`,
  paper: `${PREFIX}-paper`,
  image: `${PREFIX}-image`,
  img: `${PREFIX}-img`,
};

const Root = styled("div")(({ theme }) => ({
  [`&.${classes.root}`]: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
  },
  [`&.${classes.printArea}`]: {
    padding: "0 5rem",
  },
  [`&.${classes.paper}`]: {
    padding: theme.spacing(2),
    margin: ".5rem 3rem",
  },
  [`&.${classes.image}`]: {
    width: 128,
    height: 128,
  },
  [`&.${classes.img}`]: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
}));

export function CombineTypographyInline({ children, title }) {
  return (
    <div style={{ display: "flex" }}>
      {children !== null && (
        <>
          <Typography gutterBottom color="textSecondary" variant="body2">
            {title}:
          </Typography>
          &nbsp; &nbsp;
          <Typography color="primary" variant="body2">
            {children}
          </Typography>
        </>
      )}
    </div>
  );
}
export function CombineTypography({ children, title }) {
  return (
    <>
      {children !== null && (
        <Typography
          component="div"
          gutterBottom
          color="textSecondary"
          variant="body2"
        >
          {title}:
          <Typography color="textPrimary" variant="body2">
            &nbsp; {children}
          </Typography>
        </Typography>
      )}
    </>
  );
}

export default function ComplexGrid({ code, pageStyle }) {
  const dispatch = useDispatch();

 const {isError,isLoading,data} = useQuery(
  [REACT_QUERY_KEYS.VIEW_GRN,code],
  ()=> grnService.get(code),
  {enabled:!!code}
 )
  
  const componentRef = useRef();

  if(isLoading) {
    return <Loading/>
  }
  if(isError) {
    return <ErrorMessage/>
  }

  const TotalLinediscount = data.stockHistories
  .map((discount)=>discount.discountTotal)
  .reduce((prev,curr)=>prev+curr, 0)

  return (
    <div>
      <Root className={classes.root}>
        
          <Paper
            style={{
              width: "21cm",
              padding: "50px 30px 45px 30px",
              minHeight: "85vh",
            }}
          >
            <div className="flex-end">
              <ReactToPrint
                trigger={() => (
                  <Button style={{ marginBottom: 10 }}>Print this</Button>
                )}
                content={() => componentRef.current}
                pageStyle={pageStyle}
              />
            </div>
      
            
            <div>
            
              <div ref={componentRef} className={classes.printArea}>
                <Reports title="GOODS RECEIVED NOTE">
                  <hr />

                  <Grid container>
                    <Grid xs={7}>
                      <table>
                        <tbody>
                        <tr><td>{data.supplier?.code}</td></tr>
                          <tr><td>To : {data.supplier?.name}</td></tr>
                          <tr><td>{data.supplier.address1},</td></tr>
                          <tr><td>{data.supplier.address2}</td></tr>
                          <tr><td>{data.supplier.phone1 ? data.supplier.phone1 : data.supplier.phone2}</td></tr>
                          <tr><td>{data.remarks}</td></tr>
                        </tbody>
                      </table>
                    </Grid>
                    <Grid xs={5}>
                      <table>
                        <tbody>
                          <tr><td>{COLUMNS_NAME.GRN_NUMBER} :</td><td colSpan="2">{data.code}</td></tr>
                          <tr><td>{COLUMNS_NAME.GRN_DATE} :</td>  <td colSpan="2"> {data.grnDate}</td></tr>
                          <tr><td>{COLUMNS_NAME.INVOICE_NUMBER} :</td>  <td colSpan="2">{data.invoiceCode}</td></tr>
                          <tr><td>{COLUMNS_NAME.LOCATION} :</td> <td colSpan="2">{data.stockLocation?.name}</td></tr>
                          <tr><td>{COLUMNS_NAME.PO_NUMBER} :</td> <td colSpan="2"></td></tr>
                        </tbody>
                      </table>
                    </Grid>
                  </Grid>

                 

                  <table
                    className="print-table mt "
                    aria-label="customized table"
                  >
                    <thead className="thead">
                      <tr style={{borderBottom: "1px solid #24242450"}}>
                        <th width="10" align="center">
                          #
                        </th>
                        {/* <th>Stock Location</th> */}
                        <th>{COLUMNS_NAME.CODE}</th>
                        <th width="150" align="left">{COLUMNS_NAME.DESCRIPTION}</th>
                        {/* <th>Description</th> */}
                        <th align="right">{COLUMNS_NAME.QUANTITY}</th>
                        <th align="right">{COLUMNS_NAME.UNIT_PRICE}</th>
                        <th align="right">{COLUMNS_NAME.DISCOUNT_PERCENTAGE}</th>
                        <th align="right">{COLUMNS_NAME.DISCOUNT_AMOUNT}</th>
                        <th align="right">{COLUMNS_NAME.TOTAL}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.stockHistories.map((row, i) => (
                       <>
                        <tr>
                          <td>{i + 1}</td>
                          {/* <td align="center">{row.stockLocation?.name}</td> */}
                          <td align="center">{row.itemMaster?.code}</td>
                          <td align="left">{row.itemMaster?.name}</td>
                          {/* <td align="center">{row.itemMaster?.description}</td> */}
                          <td align="right">{row.quantity}</td>
                          <td align="right">{row.costPrice}</td>
                          <td align="right">{row.discountPercentage}% </td>
                          <td align="right"> {(row.discountAmount  ? row.discountAmount : "")} </td>
                          <td align="right">{currency(row.totalAmount)}</td>
                        </tr>
                      
                       
                       </>  
                      ))}

<tr>
                        <th align="right" width='bold' colSpan={2} >{COLUMNS_NAME.DISCOUNT_TOTAL}</th>
                     
                         <td align="right">
                      { currency(parseFloat(TotalLinediscount) + parseFloat(data.grnDiscount))} 
                         </td>
                    
                        <th align="right" colSpan={4}>
                        {COLUMNS_NAME.SUB_TOTAL}
                        </th>
                        <td align="right">
                         {currency(data.subTotalAmount)}
                        </td>
                      </tr>
                      
                      <tr>
                        <th align="right" colSpan={7}>
                        {COLUMNS_NAME.BILL_DISCOUNT_PERCENTAGE}({data.discountPercentage}%)
                        </th>
                        <td align="right">
                         {currency(data.discountPercentage/100 * data.subTotalAmount)}
                        </td>
                      </tr>
                      <tr>
                        <th align="right" colSpan={7}>
                        {COLUMNS_NAME.BILL_DISCOUNT_AMOUNT}
                        </th>
                        <td align="right">
                         {currency(data.discountAmount ? data.discountAmount : "0.00" )}
                        </td>
                      </tr>
                     
                      <tr>
                        <th align="right" colSpan={7}>
                          <strong>{COLUMNS_NAME.LAST_TOTAL}</strong>
                        </th>
                        <td align="right">
                         <strong>{currency(data.totalAmount)}</strong>
                        </td>
                      </tr>
                     
                    </tbody>
                  </table>
                     
                  
                  <div className="row" style={{ marginTop: 60 }}>
                    <div className="col-4">
                      <div
                        style={{
                          borderTop: "1px dashed #000000",
                          textAlign: "center",
                        }}
                      >
                        {COLUMNS_NAME.RECEIVED_BY}
                      </div>
                    </div>

                    <div className="col-4">
                      <div
                        style={{
                          borderTop: "1px dashed #000000",
                          textAlign: "center",
                        }}
                      >
                        {COLUMNS_NAME.CHECKED_BY}
                      </div>
                    </div>
                    
                    <div className="col-4">
                      <div
                        style={{
                          borderTop: "1px dashed #000000",
                          textAlign: "center",
                        }}
                      >
                        {COLUMNS_NAME.AUTHERIZED_SIGNATURE}
                      </div>
                    </div>
                  </div>
                </Reports>
              </div>
            </div>
          </Paper>
      
          
      
      </Root>
    </div>
  );
}
